import { toastError } from 'components/ToastComponent/ToastComponent'
import api from 'lib/api'
import { to } from 'nh-utils'

export const fetchProperty = async (id, preview) => {
  if (!id) {
    return null
  }

  const [err, res] = await to(api.get(preview ? `/${id}?preview=1` : `/${id}`))

  if (!res) {
    toastError('Erro ao buscar propriedade.')
    return { error: true, code: err || 500 }
  }
  const { data } = res.data

  return data
}
